// extracted by mini-css-extract-plugin
module.exports = {"Subscribe":"Subscribe_Subscribe__GZ7y5","TermsModal":"Subscribe_TermsModal__EWroJ"};